import {DOM} from '../core/dom';
import {FAQ} from '../core/faq';

export namespace CompaniesFAQ {
  export function onload(): void {
    FAQ.setup();
    DOM.onIdClick('companies-faq-reach-out-btn', () => DOM.redirectTo('/contact.html?mode=company'));
  }
}